import api from './api';

const continuousServiceService = {
  // Listar servicios continuos
  getContinuousServices: async (params = {}) => {
    try {
      const response = await api.get('/continuous-services', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener servicios continuos:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener servicios continuos',
        data: []
      };
    }
  },

  // Obtener un servicio continuo por ID
  getContinuousService: async (id) => {
    try {
      const response = await api.get(`/continuous-services/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener servicio continuo:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener servicio continuo'
      };
    }
  },

  // Crear servicio continuo
  createContinuousService: async (data) => {
    try {
      const response = await api.post('/continuous-services', data);
      return response.data;
    } catch (error) {
      console.error('Error al crear servicio continuo:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear servicio continuo',
        errors: error.response?.data?.errors || {}
      };
    }
  },

  // Actualizar cabecera del servicio continuo (fechas, observaciones)
  updateContinuousService: async (id, data) => {
    try {
      const response = await api.put(`/continuous-services/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar servicio continuo:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar servicio continuo'
      };
    }
  },

  // Ajustar montos (IGV y/o Total) por diferencias de decimales
  updateAmounts: async (id, data) => {
    try {
      const response = await api.patch(`/continuous-services/${id}/amounts`, data);
      return response.data;
    } catch (error) {
      console.error('Error al ajustar montos:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al ajustar montos',
        errors: error.response?.data?.errors || {}
      };
    }
  },

  // Cerrar servicio continuo
  closeContinuousService: async (id, data = {}) => {
    try {
      const response = await api.patch(`/continuous-services/${id}/close`, data);
      return response.data;
    } catch (error) {
      console.error('Error al cerrar servicio continuo:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al cerrar servicio continuo'
      };
    }
  },

  // Abrir servicio continuo (volver a estado editable)
  openContinuousService: async (id) => {
    try {
      const response = await api.patch(`/continuous-services/${id}/open`);
      return response.data;
    } catch (error) {
      console.error('Error al abrir servicio continuo:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al abrir servicio continuo'
      };
    }
  },

  // Listar registros de avance
  getProgress: async (id) => {
    try {
      // Los registros vienen con el servicio continuo en show
      const response = await api.get(`/continuous-services/${id}`);
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data.progress || []
        };
      }
      return {
        success: false,
        message: 'Error al obtener registros de avance',
        data: []
      };
    } catch (error) {
      console.error('Error al obtener registros de avance:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener registros de avance',
        data: []
      };
    }
  },

  // Crear registro de avance
  createProgress: async (id, data) => {
    try {
      const response = await api.post(`/continuous-services/${id}/progress`, data);
      return response.data;
    } catch (error) {
      console.error('Error al crear registro de avance:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear registro de avance',
        errors: error.response?.data?.errors || {}
      };
    }
  },

  // Actualizar registro de avance
  updateProgress: async (id, progressId, data) => {
    try {
      const response = await api.put(`/continuous-services/${id}/progress/${progressId}`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar registro de avance:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar registro de avance',
        errors: error.response?.data?.errors || {}
      };
    }
  },

  // Eliminar registro de avance
  deleteProgress: async (id, progressId) => {
    try {
      const response = await api.delete(`/continuous-services/${id}/progress/${progressId}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar registro de avance:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al eliminar registro de avance'
      };
    }
  },

  // Importar múltiples registros de avance
  importProgress: async (id, data) => {
    try {
      const response = await api.post(`/continuous-services/${id}/progress/import`, data);
      return response.data;
    } catch (error) {
      console.error('Error al importar registros de avance:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al importar registros de avance',
        errors: error.response?.data?.errors || {}
      };
    }
  }
};

export default continuousServiceService;
